/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import partnersSectionStyles from "./partnersSectionStyles";
import Container from "../../../Container/Container";
import Grid from "@mui/material/Grid";
import advocard from "../../../../assets/img/partner/logo_advocard.svg";
import arag from "../../../../assets/img/partner/logo_arag.svg";
import check from "../../../../assets/img/partner/logo_check24.svg";
import nrv from "../../../../assets/img/partner/logo_nrv.svg";
import wbs from "../../../../assets/img/partner/logo_wbs.svg";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";

const PartnersSection = () => {
  return (
    <Box sx={partnersSectionStyles.partnerSectionContainer}>
      <Typography variant={"h2"}>Unsere Partner</Typography>
      <Container>
        <Grid
          container
          spacing={4}
          sx={{
            justifyContent: "space-evenly",
            alignItems: "center",
          }}
        >
          <Grid
            sx={partnersSectionStyles.gridItem}
            size={{
              md: 2,
              xs: 6,
            }}
          >
            <Box sx={partnersSectionStyles.logoContainer}>
              <Box component={"img"} src={advocard} sx={partnersSectionStyles.logo} alt={"Logo Advocard"} />
            </Box>
          </Grid>
          <Grid
            sx={partnersSectionStyles.gridItem}
            size={{
              md: 2,
              xs: 6,
            }}
          >
            <Box sx={partnersSectionStyles.logoContainer}>
              <Box component={"img"} src={arag} sx={partnersSectionStyles.logo} alt={"Logo Arag"} />
            </Box>
          </Grid>
          <Grid
            sx={partnersSectionStyles.gridItem}
            size={{
              md: 2,
              xs: 6,
            }}
          >
            <Box sx={partnersSectionStyles.logoContainer}>
              <Box component={"img"} src={wbs} sx={partnersSectionStyles.logo} alt={"Logo WBS"} />
            </Box>
          </Grid>
          <Grid
            sx={partnersSectionStyles.gridItem}
            size={{
              md: 2,
              xs: 6,
            }}
          >
            <Box sx={partnersSectionStyles.logoContainer}>
              <Box component={"img"} src={check} sx={partnersSectionStyles.logo} alt={"Logo CHECK24"} />
            </Box>
          </Grid>
          <Grid
            sx={partnersSectionStyles.gridItem}
            size={{
              md: 2,
              xs: 6,
            }}
          >
            <Box sx={partnersSectionStyles.logoContainer}>
              <Box component={"img"} src={nrv} sx={partnersSectionStyles.logo} alt={"Logo NRV"} />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default PartnersSection;
